module.exports = __webpack_public_path__ + "352052b6ef44085c49b106a958d0794d.svg";